import { useEffect } from 'react'
import { BILLING_ENABLED, useAccessStore } from '@/services/access'

function hasStoredAuthSession() {
  try {
    return Object.keys(localStorage).some((key) => key.startsWith('sb-') && key.endsWith('-auth-token'))
  } catch {
    return false
  }
}

export function BillingSessionSync() {
  const setEntitlement = useAccessStore((s) => s.setEntitlement)
  const setEntitlementState = useAccessStore((s) => s.setEntitlementState)

  useEffect(() => {
    if (!BILLING_ENABLED) return
    let active = true
    let unsubscribe: (() => void) | undefined

    async function refreshEntitlement(signedIn: boolean) {
      if (!signedIn) {
        setEntitlement(false)
        return
      }
      setEntitlementState('loading')
      try {
        const { getEntitlement } = await import('@/services/billing')
        setEntitlement((await getEntitlement()).fullAccess)
      } catch {
        setEntitlement(false)
      }
    }

    void import('@/services/supabase/supabaseClient').then(({ getSupabaseClient }) => {
      if (!active) return
      const client = getSupabaseClient()
      if (!client) return
      if (hasStoredAuthSession()) void refreshEntitlement(true)
      const { data } = client.auth.onAuthStateChange((_event, session) => {
        // Leave the auth callback before making another client-backed request;
        // Supabase may still be holding its session lock while this fires.
        queueMicrotask(() => { if (active) void refreshEntitlement(Boolean(session)) })
      })
      unsubscribe = () => data.subscription.unsubscribe()
    })
    return () => {
      active = false
      unsubscribe?.()
    }
  }, [setEntitlement, setEntitlementState])
  return null
}
